const allElementsHaveSameValue = (arr, property) => arr.every((obj) => obj?.[property] === arr[0]?.[property]);

const checkForCollectionsSortingsEquality = (sortingsArray) => {
  const hasSameType = allElementsHaveSameValue(sortingsArray, 'type');
  const hasSameOrder = allElementsHaveSameValue(sortingsArray, 'order');
  return hasSameOrder && hasSameType;
};

export default checkForCollectionsSortingsEquality;
